
<template>
  <div class="video-library-page">
    <el-container class="library-container">
      <!-- 左侧文件夹菜单 -->
      <el-aside width="220px" class="folder-sidebar">
        <div class="sidebar-header">
          <h3><i class="el-icon-folder-opened"></i> 视频库</h3>
        </div>
        <div class="sidebar-actions">
          <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="showCreateFolderDialog"
              class="create-folder-btn"
          >
            新建文件夹
          </el-button>
        </div>
        <div class="folder-menu">
          <div
              v-for="(folder, index) in folderList"
              :key="index"
              class="folder-item"
              :class="{ 'active': selectedFolder === folder.value }"
              @click="selectFolder(folder.value)"
          >
            <i class="el-icon-folder"></i>
            <span class="folder-name">{{ folder.label }}</span>
            <el-badge
                v-if="folder.count !== undefined"
                :value="folder.count"
                class="folder-badge"
            />
          </div>

          <div
              class="folder-item all-folder"
              :class="{ 'active': !selectedFolder }"
              @click="selectFolder('')"
          >
            <i class="el-icon-collection"></i>
            <span class="folder-name">全部视频</span>
          </div>
        </div>
      </el-aside>

      <!-- 右侧内容区 -->
      <el-main class="content-main">
        <el-card shadow="never" class="query-card">
          <div slot="header" class="card-header">
            <div class="header-left">
              <h3>
                <i class="el-icon-video-camera"></i>
                {{ currentFolderLabel }}
              </h3>
              <el-tag v-if="selectedFolder" type="success" size="small" style="margin-left: 12px">
                类型: {{ selectedFolder }}
              </el-tag>
            </div>


            <div class="header-actions">
              <el-button-group style="margin-right: 10px">
                <el-button
                    :type="viewMode === 'table' ? 'primary' : ''"
                    icon="el-icon-s-grid"
                    size="small"
                    @click="viewMode = 'table'"
                >
                  表格
                </el-button>
                <el-button
                    :type="viewMode === 'card' ? 'primary' : ''"
                    icon="el-icon-menu"
                    size="small"
                    @click="viewMode = 'card'"
                >
                  卡片
                </el-button>
                <el-button
                    :type="viewMode === 'thumbnail' ? 'primary' : ''"
                    icon="el-icon-picture"
                    size="small"
                    @click="viewMode = 'thumbnail'"
                >
                  缩略图
                </el-button>
                <el-button
                    :type="viewMode === 'list' ? 'primary' : ''"
                    icon="el-icon-s-order"
                    size="small"
                    @click="viewMode = 'list'"
                >
                  列表
                </el-button>
              </el-button-group>

              <el-button
                  type="primary"
                  icon="el-icon-refresh"
                  @click="handleRefresh"
                  :loading="loading"
                  size="small"
              >
                刷新
              </el-button>

              <el-button
                  type="primary"
                  icon="el-icon-download"
                  @click="handleDownloadCurrentPageVideos"
                  :loading="downloadLoading"
                  :disabled="currentPageDownloadableVideos.length === 0"
                  size="small"
              >
                下载当前页
              </el-button>

              <el-button
                  type="warning"
                  icon="el-icon-view"
                  @click="refreshCurrentPageMaterialReview"
                  :loading="materialReviewLoading"
                  :disabled="tableData.length === 0"
                  size="small"
              >
                刷新审核
              </el-button>

              <el-button
                  type="danger"
                  icon="el-icon-delete"
                  @click="handleDeleteRejectedOnPage"
                  :loading="deleteLoading"
                  :disabled="currentPageRejectedVideos.length === 0"
                  size="small"
              >
                删除不过审
              </el-button>

              <el-button
                  type="info"
                  icon="el-icon-document"
                  @click="openDeletedRecordsDialog"
                  size="small"
              >
                删除记录
              </el-button>

              <el-button
                  type="success"
                  icon="el-icon-upload2"
                  @click="showUploadDialog = true"
                  size="small"
              >
                上传视频
              </el-button>
            </div>
          </div>
          <!-- 筛选区 -->
          <el-form :model="queryForm" inline class="query-form">
            <el-form-item label="上传用户">
              <el-input
                  v-model="queryForm.uploadPerson"
                  placeholder="请输入上传用户（可选）"
                  clearable
                  style="width: 200px"
                  @keyup.enter.native="handleQuery"
              />
            </el-form-item>

            <!-- 动态添加的高级筛选条件 -->
            <template v-for="(filter, index) in advancedFilters">
              <!-- 消耗范围 -->
              <el-form-item
                  v-if="filter.type === 'cost'"
                  :key="'cost-' + index"
                  label="消耗范围"
                  class="advanced-filter-item"
              >
                <el-input-number
                    v-model="filter.minValue"
                    placeholder="最小"
                    :min="0"
                    :precision="2"
                    controls-position="right"
                    style="width: 110px"
                />
                <span style="margin: 0 4px">-</span>
                <el-input-number
                    v-model="filter.maxValue"
                    placeholder="最大"
                    :min="0"
                    :precision="2"
                    controls-position="right"
                    style="width: 110px"
                />
                <el-button
                    type="text"
                    icon="el-icon-close"
                    @click="removeAdvancedFilter(index)"
                    style="margin-left: 4px; color: #f56c6c"
                ></el-button>
              </el-form-item>

              <!-- ROAS范围 -->
              <el-form-item
                  v-if="filter.type === 'roas'"
                  :key="'roas-' + index"
                  label="ROAS范围"
                  class="advanced-filter-item"
              >
                <el-input-number
                    v-model="filter.minValue"
                    placeholder="最小"
                    :min="0"
                    :precision="4"
                    controls-position="right"
                    style="width: 110px"
                />
                <span style="margin: 0 4px">-</span>
                <el-input-number
                    v-model="filter.maxValue"
                    placeholder="最大"
                    :min="0"
                    :precision="4"
                    controls-position="right"
                    style="width: 110px"
                />
                <el-button
                    type="text"
                    icon="el-icon-close"
                    @click="removeAdvancedFilter(index)"
                    style="margin-left: 4px; color: #f56c6c"
                ></el-button>
              </el-form-item>

              <!-- 最小展示 -->
              <el-form-item
                  v-if="filter.type === 'impressions'"
                  :key="'impressions-' + index"
                  label="最小展示"
                  class="advanced-filter-item"
              >
                <el-input-number
                    v-model="filter.value"
                    placeholder="请输入"
                    :min="0"
                    controls-position="right"
                    style="width: 150px"
                />
                <el-button
                    type="text"
                    icon="el-icon-close"
                    @click="removeAdvancedFilter(index)"
                    style="margin-left: 4px; color: #f56c6c"
                ></el-button>
              </el-form-item>

              <!-- 关键词 -->
              <el-form-item
                  v-if="filter.type === 'keyword'"
                  :key="'keyword-' + index"
                  label="关键词"
                  class="advanced-filter-item"
              >
                <el-input
                    v-model="filter.value"
                    placeholder="搜索文件名"
                    clearable
                    style="width: 200px"
                />
                <el-button
                    type="text"
                    icon="el-icon-close"
                    @click="removeAdvancedFilter(index)"
                    style="margin-left: 4px; color: #f56c6c"
                ></el-button>
              </el-form-item>

              <!-- 排序方式 -->
              <el-form-item
                  v-if="filter.type === 'sortBy'"
                  :key="'sortBy-' + index"
                  label="排序字段"
                  class="advanced-filter-item"
              >
                <el-select
                    v-model="filter.value"
                    placeholder="选择排序"
                    style="width: 150px"
                >
                  <el-option label="消耗" value="lifetimeCost"></el-option>
                  <el-option label="ROAS" value="lifetimeRoas"></el-option>
                  <el-option label="展示数" value="lifetimeImpressions"></el-option>
                  <el-option label="点击数" value="lifetimeClicks"></el-option>
                  <el-option label="转化数" value="lifetimeConversions"></el-option>
                  <el-option label="CTR" value="lifetimeCtr"></el-option>
                </el-select>
                <el-button
                    type="text"
                    icon="el-icon-close"
                    @click="removeAdvancedFilter(index)"
                    style="margin-left: 4px; color: #f56c6c"
                ></el-button>
              </el-form-item>

              <!-- 排序顺序 -->
              <el-form-item
                  v-if="filter.type === 'order'"
                  :key="'order-' + index"
                  label="排序顺序"
                  class="advanced-filter-item"
              >
                <el-select
                    v-model="filter.value"
                    placeholder="选择顺序"
                    style="width: 120px"
                >
                  <el-option label="降序" value="desc"></el-option>
                  <el-option label="升序" value="asc"></el-option>
                </el-select>
                <el-button
                    type="text"
                    icon="el-icon-close"
                    @click="removeAdvancedFilter(index)"
                    style="margin-left: 4px; color: #f56c6c"
                ></el-button>
              </el-form-item>
            </template>

            <!-- 添加筛选条件按钮 -->
            <el-form-item>
              <el-dropdown @command="handleAddFilter" trigger="click">
                <el-button type="primary" plain icon="el-icon-plus" size="small">
                  添加筛选
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="cost" :disabled="hasFilter('cost')">
                    <i class="el-icon-money"></i> 消耗范围
                  </el-dropdown-item>
                  <el-dropdown-item command="roas" :disabled="hasFilter('roas')">
                    <i class="el-icon-data-line"></i> ROAS范围
                  </el-dropdown-item>
                  <el-dropdown-item command="impressions" :disabled="hasFilter('impressions')">
                    <i class="el-icon-view"></i> 最小展示
                  </el-dropdown-item>
                  <el-dropdown-item command="keyword" :disabled="hasFilter('keyword')">
                    <i class="el-icon-search"></i> 关键词
                  </el-dropdown-item>
                  <el-dropdown-item command="sortBy" :disabled="hasFilter('sortBy')">
                    <i class="el-icon-sort"></i> 排序字段
                  </el-dropdown-item>
                  <el-dropdown-item command="order" :disabled="hasFilter('order')">
                    <i class="el-icon-top"></i> 排序顺序
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handleQuery" :loading="loading">
                查询
              </el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>


          <!-- 筛选区 -->
<!--          <el-form :model="queryForm" inline class="query-form">-->
<!--            <el-form-item label="上传用户">-->
<!--              <el-input-->
<!--                  v-model="queryForm.uploadPerson"-->
<!--                  placeholder="请输入上传用户（可选）"-->
<!--                  clearable-->
<!--                  style="width: 200px"-->
<!--                  @keyup.enter.native="handleQuery"-->
<!--              />-->
<!--            </el-form-item>-->

<!--            <el-form-item>-->
<!--              <el-button type="primary" @click="handleQuery" :loading="loading">-->
<!--                查询-->
<!--              </el-button>-->
<!--              <el-button @click="handleReset">重置</el-button>-->
<!--            </el-form-item>-->
<!--          </el-form>-->

          <!-- 统计信息 -->
          <div class="stats-bar" v-if="pagination.totalElements > 0">
            <el-tag type="info" size="medium">
              总计: {{ pagination.totalElements }} 个视频
            </el-tag>
            <el-tag type="success" size="medium" style="margin-left: 8px">
              当前页: {{ pagination.page }} / {{ pagination.totalPages }}
            </el-tag>
            <el-tag
                v-if="selectedVideos.length > 0"
                type="primary"
                size="medium"
                style="margin-left: 8px"
            >
              已选中: {{ selectedVideos.length }} 个
            </el-tag>
            <el-tag type="success" size="medium" style="margin-left: 8px">
              通过: {{ reviewStats.passed }}
            </el-tag>
            <el-tag type="danger" size="medium" style="margin-left: 8px">
              失败: {{ reviewStats.rejected }}
            </el-tag>
            <el-tag type="warning" size="medium" style="margin-left: 8px">
              审核中: {{ reviewStats.pending }}
            </el-tag>
            <el-tag type="info" size="medium" style="margin-left: 8px">
              未投放: {{ reviewStats.noAdMaterial }}
            </el-tag>
          </div>

          <!-- 批量操作区 -->
          <div class="batch-actions" v-if="selectedVideos.length > 0">
            <el-alert
                :title="`已选择 ${selectedVideos.length} 个视频`"
                type="success"
                :closable="false"
                show-icon
            />
            <div class="action-buttons">
              <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-check"
                  @click="handleSelectAllOnPage"
              >
                全选当前页
              </el-button>
              <el-button
                  type="warning"
                  size="small"
                  icon="el-icon-close"
                  @click="handleClearSelection"
              >
                取消选择
              </el-button>
              <el-button
                  type="danger"
                  size="small"
                  icon="el-icon-delete"
                  :loading="deleteLoading"
                  @click="handleBatchDelete"
              >
                批量删除
              </el-button>
              <el-button
                  type="danger"
                  size="small"
                  plain
                  icon="el-icon-delete"
                  :loading="deleteLoading"
                  :disabled="selectedRejectedVideos.length === 0"
                  @click="handleDeleteSelectedRejected"
              >
                删除选中不过审
              </el-button>

            </div>
          </div>

          <!-- 表格视图 -->
          <el-table
              v-if="viewMode === 'table'"
              :data="tableData"
              v-loading="loading"
              border
              stripe
              max-height="600"
              style="margin-top: 16px"
              @selection-change="handleSelectionChange"
          >
            <el-table-column
                type="selection"
                width="55"
                :selectable="checkSelectable"
            />
            <el-table-column
                prop="fileName"
                label="文件名"
                min-width="180"
                show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                <span>{{ row.fileName || row.originalFileName }}</span>
              </template>
            </el-table-column>

            <el-table-column
                prop="videoId"
                label="视频ID"
                width="330"
            >
              <template slot-scope="{ row }">
                <div class="id-cell" v-if="row.videoId">
                  <span>{{ row.videoId }}</span>
                  <i
                      class="el-icon-document-copy copy-icon"
                      @click="copyToClipboard(row.videoId)"
                  ></i>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column label="审核统计" width="180">
              <template slot-scope="{ row }">
                <el-tag :type="getReviewTagType(row)" size="mini">
                  {{ getReviewSummaryText(row) }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column
                prop="materialId"
                label="素材ID"
                width="300"
            >
              <template slot-scope="{ row }">
                <div class="id-cell" v-if="row.materialId">
                  <span>{{ row.materialId }}</span>
                  <i
                      class="el-icon-document-copy copy-icon"
                      @click="copyToClipboard(row.materialId)"
                  ></i>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column
                label="视频信息"
                width="150"
            >
              <template slot-scope="{ row }">
                <div v-if="row.duration">
                  <div>时长: {{ formatDuration(row.duration) }}</div>
                  <div v-if="row.width && row.height">
                    分辨率: {{ row.width }}x{{ row.height }}
                  </div>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column
                label="文件大小"
                width="120"
            >
              <template slot-scope="{ row }">
                {{ formatFileSize(row.fileSize) }}
              </template>
            </el-table-column>

            <el-table-column
                prop="uploadStatus"
                label="状态"
                width="100"
            >
              <template slot-scope="{ row }">
                <el-tag :type="getStatusType(row.uploadStatus)" size="small">
                  {{ getStatusText(row.uploadStatus) }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column
                prop="recordCreatedAt"
                label="上传时间"
                width="180"
            >
              <template slot-scope="{ row }">
                {{ formatTime(row.recordCreatedAt) }}
              </template>
            </el-table-column>

            <el-table-column
                label="操作"
                width="190"
            >
              <template slot-scope="{ row }">
                <el-button
                    v-if="row.previewUrl"
                    type="text"
                    size="small"
                    @click="handlePreview(row)"
                >
                  预览
                </el-button>
                <el-button
                    type="text"
                    size="small"
                    @click="handleCopyInfo(row)"
                >
                  复制信息
                </el-button>
                <el-button
                    type="text"
                    size="small"
                    class="danger-text-btn"
                    @click="handleDeleteVideo(row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 卡片视图 -->
          <div
              v-if="viewMode === 'card'"
              v-loading="loading"
              class="card-view"
          >
            <div class="video-cards">
              <div
                  v-for="(row, index) in tableData"
                  :key="index"
                  class="video-card"
                  :class="{ 'selected': isVideoSelected(row) }"
              >
                <el-checkbox
                    v-model="row._selected"
                    class="video-checkbox"
                    @change="handleCardSelectionChange(row)"
                    @click.stop

                    :disabled="!row.imageId"
                ></el-checkbox>

                <div class="missing-badge" v-if="!row.imageId">
                  <el-tag size="mini" type="warning" effect="dark">
                    <i class="el-icon-warning"></i> 缺少封面ID
                  </el-tag>
                </div>

                <div class="card-preview" v-if="row.previewUrl">
                  <video
                      :src="row.previewUrl"
                      class="card-video"
                      preload="metadata"
                      controls
                      @click.stop
                  ></video>
                </div>
                <div class="card-preview no-preview" v-else>
                  <i class="el-icon-video-camera"></i>
                  <span>无预览</span>
                </div>

                <div class="card-content">
                  <div class="card-title" :title="row.fileName || row.originalFileName">
                    {{ row.fileName || row.originalFileName }}
                  </div>
                  <div class="review-summary-line">
                    <el-tag :type="getReviewTagType(row)" size="mini">
                      {{ getReviewSummaryText(row) }}
                    </el-tag>
                  </div>

                  <!-- 性能数据 -->
                  <div class="card-performance" v-if="row.lifetimeCost !== null && row.lifetimeCost !== undefined">
                    <div class="perf-item cost-item">
                      <i class="el-icon-money"></i>
                      <span>¥{{ row.lifetimeCost.toFixed(2) }}</span>
                    </div>
                    <div class="perf-item roas-item" v-if="row.lifetimeRoas !== null && row.lifetimeRoas !== undefined">
                      <i class="el-icon-data-line"></i>
                      <span>{{ row.lifetimeRoas.toFixed(2) }}</span>
                    </div>
                  </div>

                  <div class="card-info">
                    <div class="info-item" v-if="row.uploadPerson">
                      <span class="label">上传用户:</span>
                      <el-tag size="mini" type="success" effect="plain">
                        {{ row.uploadPerson }}
                      </el-tag>
                    </div>

                    <div class="info-item" v-if="row.uploadVideoType">
                      <span class="label">上传类型:</span>
                      <el-tag size="mini" effect="light">
                        {{ row.uploadVideoType }}
                      </el-tag>
                    </div>

                    <div class="info-item" v-if="row.materialId">
                      <span class="label">素材ID:</span>
                      <span class="value">{{ row.materialId }}</span>
                      <i
                          class="el-icon-document-copy copy-icon-small"
                          @click="copyToClipboard(row.materialId)"
                      ></i>
                    </div>

                    <div class="info-item" v-if="row.duration">
                      <span class="label">时长:</span>
                      <span class="value">{{ formatDuration(row.duration) }}</span>
                    </div>

                    <div class="info-item" v-if="row.recordCreatedAt">
                      <span class="label">上传时间:</span>
                      <span class="value">{{ formatTime(row.recordCreatedAt) }}</span>
                    </div>
                  </div>
                  <div class="card-actions">
                    <el-button
                        size="mini"
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        :loading="deleteLoading"
                        @click.stop="handleDeleteVideo(row)"
                    >
                      删除
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 缩略图视图 -->
          <div
              v-else-if="viewMode === 'thumbnail'"
              v-loading="loading"
              class="thumbnail-view"
          >
            <div class="thumbnail-grid">
              <div
                  v-for="(row, index) in tableData"
                  :key="index"
                  class="thumbnail-item"
                  :class="{
                    'selected': isVideoSelected(row),
                    'disabled': !row.imageId
                  }"
              >
                <div class="thumbnail-checkbox">
                  <el-checkbox
                      v-model="row._selected"
                      :disabled="!row.imageId"
                      @click.native.stop
                      @change="handleCardSelectionChange(row)"
                  ></el-checkbox>
                </div>

                <div class="thumbnail-missing-badge" v-if="!row.imageId">
                  <i class="el-icon-warning"></i>
                </div>

                <div class="thumbnail-preview">
                  <video
                      v-if="row.previewUrl"
                      :src="row.previewUrl"
                      preload="metadata"
                      class="thumbnail-video"
                      muted
                      @click.stop

                      @mouseenter="handleVideoHover($event, true)"
                      @mouseleave="handleVideoHover($event, false)"
                  ></video>
<!--                  <div v-else class="no-thumbnail-placeholder">-->
<!--                    <i class="el-icon-video-camera"></i>-->
<!--                  </div>-->

<!--                  <div class="play-overlay" v-if="row.previewUrl">-->
<!--                    <i class="el-icon-video-play"></i>-->
<!--                  </div>-->
                </div>

                <div class="thumbnail-info">
                  <el-tooltip :content="row.fileName || row.originalFileName" placement="top">
                    <div class="thumbnail-name">{{ truncate(row.fileName || row.originalFileName, 18) }}</div>
                  </el-tooltip>

                  <!-- 性能数据 -->
                  <div class="thumbnail-performance" v-if="row.lifetimeCost !== null && row.lifetimeCost !== undefined">
                    <div class="perf-item cost-item">
                      <i class="el-icon-money"></i>
                      <span>¥{{ row.lifetimeCost.toFixed(2) }}</span>
                    </div>
                    <div class="perf-item roas-item" v-if="row.lifetimeRoas !== null && row.lifetimeRoas !== undefined">
                      <i class="el-icon-data-line"></i>
                      <span>{{ row.lifetimeRoas.toFixed(2) }}</span>
                    </div>
                  </div>

                  <div class="thumbnail-meta">
                    <el-tag
                        v-if="row.uploadPerson"
                        size="mini"
                        type="success"
                        effect="plain"
                        class="meta-tag"
                    >
                      {{ row.uploadPerson }}
                    </el-tag>
                    <span v-if="row.duration" class="duration-text">
                      {{ formatDuration(row.duration) }}
                    </span>
                    <el-button
                        type="text"
                        icon="el-icon-delete"
                        class="thumbnail-delete-btn"
                        :loading="deleteLoading"
                        @click.stop="handleDeleteVideo(row)"
                    ></el-button>
                  </div>
                </div>
              </div>
            </div>

            <el-empty
                v-if="!loading && tableData.length === 0"
                description="暂无视频记录"
                :image-size="120"
            />
          </div>
          <!-- 列表视图（文件管理器风格） -->
          <div
              v-else-if="viewMode === 'list'"
              v-loading="loading"
              class="list-view"
              ref="listViewContainer"
              @mousedown="handleListMouseDown"
          >
            <div class="file-list">
              <div
                  v-for="(row, index) in tableData"
                  :key="index"
                  class="file-item"
                  :class="{
                'selected': isVideoSelected(row),
                'disabled': !row.imageId,
                'selecting': isSelectingListItem(row)
              }"
                  :data-index="index"
                  @click="handleFileItemClick(row)"
              >
                <!-- 文件图标/封面 -->
                <div class="file-icon">
                  <img
                      v-if="row.videoCoverUrl"
                      :src="row.videoCoverUrl"
                      class="file-thumbnail"
                      @error="handleImageError($event, row)"
                      alt="视频封面"
                  />
                  <i v-else class="el-icon-video-camera"></i>
                </div>

                <!-- 文件信息 -->
                <div class="file-info">
                  <div class="file-name" :title="row.fileName || row.originalFileName">
                    {{ row.fileName || row.originalFileName }}
                  </div>
                  <div class="file-meta">
                <span class="meta-item" v-if="row.uploadPerson">
                  <el-tag size="mini" type="success" effect="plain">
                    {{ row.uploadPerson }}
                  </el-tag>
                </span>
                    <span class="meta-item" v-if="row.uploadVideoType">
                  <el-tag size="mini" effect="light">
                    {{ row.uploadVideoType }}
                  </el-tag>
                </span>
                    <span class="meta-item" v-if="row.fileSize">
                  {{ formatFileSize(row.fileSize) }}
                </span>
                    <span class="meta-separator" v-if="row.fileSize && row.recordCreatedAt">|</span>
                    <span class="meta-item" v-if="row.recordCreatedAt">
                  {{ formatTime(row.recordCreatedAt) }}
                </span>
                    <span class="meta-item" v-if="row.duration">
                  时长: {{ formatDuration(row.duration) }}
                </span>
                  </div>
                </div>

                <!-- 预览按钮 -->
                <el-button
                    v-if="row.previewUrl"
                    type="text"
                    icon="el-icon-video-play"
                    @click.stop="handlePreview(row)"
                    class="file-preview-btn"
                ></el-button>
                <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click.stop="handleDeleteVideo(row)"
                    class="file-delete-btn"
                    :loading="deleteLoading"
                ></el-button>
              </div>
            </div>

            <!-- 空状态 -->
            <el-empty
                v-if="!loading && tableData.length === 0"
                description="暂无视频记录"
                :image-size="120"
            />

            <!-- 选择框 -->
            <div
                v-if="isDraggingList"
                class="list-selection-box"
                :style="listSelectionBoxStyle"
            ></div>
          </div>
          <!-- 分页区 -->
          <div class="pagination-container" v-if="pagination.totalElements > 0">
            <el-pagination
                background
                :current-page="pagination.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagination.pageSize"
                :total="pagination.totalElements"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
            />
          </div>

          <!-- 空状态 -->
          <el-empty
              v-if="!loading && tableData.length === 0"
              description="暂无视频记录"
              :image-size="120"
          >
            <el-button type="primary" @click="handleQuery">
              点击查询
            </el-button>
          </el-empty>
        </el-card>
      </el-main>
    </el-container>

    <!-- 预览对话框 -->
    <el-dialog
        title="视频预览"
        :visible.sync="previewVisible"
        width="600px"
        append-to-body
    >
      <video
          v-if="previewUrl"
          :src="previewUrl"
          controls
          style="width: 100%"
      ></video>
    </el-dialog>


    <!-- 预览对话框 -->
    <el-dialog
        title="视频预览"
        :visible.sync="previewVisible"
        width="600px"
        append-to-body
    >
      <video
          v-if="previewUrl"
          :src="previewUrl"
          controls          style="width: 100%"
      ></video>
    </el-dialog>

    <!-- 预览对话框 -->
    <el-dialog
        title="视频预览"
        :visible.sync="previewVisible"
        width="600px"
        append-to-body
    >
      <video
          v-if="previewUrl"
          :src="previewUrl"
          controls          style="width: 100%"
      ></video>
    </el-dialog>

    <el-dialog
        title="删除记录"
        :visible.sync="deleteRecordDialogVisible"
        width="900px"
        append-to-body
    >
      <div class="delete-record-toolbar">
        <el-input
            v-model="deletedRecordQuery.uploadPerson"
            placeholder="上传用户"
            clearable
            size="small"
            style="width: 160px"
            @keyup.enter.native="loadDeletedRecords"
        />
        <el-input
            v-model="deletedRecordQuery.fileName"
            placeholder="文件名"
            clearable
            size="small"
            style="width: 220px"
            @keyup.enter.native="loadDeletedRecords"
        />
        <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            :loading="deletedRecordLoading"
            @click="loadDeletedRecords"
        >
          查询
        </el-button>
        <el-button
            size="small"
            icon="el-icon-refresh-left"
            @click="resetDeletedRecordQuery"
        >
          重置
        </el-button>
      </div>

      <el-table
          :data="deletedRecords"
          v-loading="deletedRecordLoading"
          border
          stripe
          max-height="520"
      >
        <el-table-column prop="fileName" label="文件名" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.fileName || row.originalFileName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="videoId" label="视频 ID" min-width="180" show-overflow-tooltip />
        <el-table-column prop="materialId" label="素材 ID" min-width="180" show-overflow-tooltip />
        <el-table-column prop="deletedBy" label="删除人" width="120" />
        <el-table-column prop="deletedAt" label="删除时间" width="180">
          <template slot-scope="{ row }">
            {{ formatTime(row.deletedAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="deleteReason" label="删除原因" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.deleteReason || '-' }}
          </template>
        </el-table-column>
      </el-table>

      <div class="delete-record-pagination">
        <el-pagination
            background
            :current-page="deletedRecordPagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="deletedRecordPagination.pageSize"
            :total="deletedRecordPagination.totalElements"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleDeletedRecordSizeChange"
            @current-change="handleDeletedRecordPageChange"
        />
      </div>
    </el-dialog>

    <!-- 视频上传对话框 -->
    <el-dialog
        title="批量视频上传"
        :visible.sync="showUploadDialog"
        width="90%"
        top="5vh"
        :close-on-click-modal="false"
        class="upload-dialog"
    >
      <video-upload-component
          ref="uploadComponent"
          :base-url="baseUrl"
          :default-advertiser-id="advertiserId"
          :default-upload-type="selectedFolder || uploadVideoType"
          @upload-complete="handleUploadComplete"
      />
    </el-dialog>
    <!-- 新建文件夹对话框 -->
    <el-dialog
        title="新建文件夹"
        :visible.sync="createFolderDialogVisible"
        width="400px"
        append-to-body
    >
      <el-form :model="createFolderForm" label-width="120px">
        <el-form-item label="文件夹名称" required>
          <el-input
              v-model="createFolderForm.folderName"
              placeholder="请输入文件夹名称"
              maxlength="20"
              show-word-limit
              @keyup.enter.native="confirmCreateFolder"
          />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="createFolderDialogVisible = false">取消</el-button>
        <el-button
            type="primary"
            @click="confirmCreateFolder"
            :loading="creatingFolder"
            :disabled="!createFolderForm.folderName.trim()"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import VideoUploadComponent from '../ads/VideoUploadComponent.vue'

export default {
  name: 'VideoLibrary',
  components: {
    VideoUploadComponent
  },
  props: {
    baseUrl: {
      type: String,
      // default: 'https://tiktoktf.darknight.games/api/api'
      default: 'https://tiktoktf.darknight.games/api/api'
    },

    advertiserId: {
      type: String,
      default: '7598883753192357896'
    },

    uploadVideoType: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      folderList: [
        { label: '找茬', value: '找茬', count: undefined },
        { label: '脑洞', value: '脑洞', count: undefined },
        { label: '拼图', value: '拼图', count: undefined },
        { label: '麻将', value: '麻将', count: undefined },
        { label: '数独', value: '数独', count: undefined }
      ],

      selectedFolder: '',

      queryForm: {
        uploadPerson: this.$store.state.username || this.$store.state.user?.username || '',
        uploadType: ''
      },
      // 高级筛选条件列表
      advancedFilters: [],

      tableData: [],
      loading: false,
      materialReviewLoading: false,
      downloadLoading: false,

      pagination: {
        page: 1,
        pageSize: 20,
        totalElements: 0,
        totalPages: 0,
        hasNext: false,
        hasPrevious: false
      },

      previewVisible: false,
      previewUrl: '',

      viewMode: 'card',

      selectedVideos: [],
      selectedVideoIds: new Set(),
      deleteLoading: false,
      deleteRecordDialogVisible: false,
      deletedRecords: [],
      deletedRecordLoading: false,
      deletedRecordQuery: {
        uploadPerson: '',
        fileName: ''
      },
      deletedRecordPagination: {
        page: 1,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0
      },

      assignDialogVisible: false,

      hasLoadedOnce: false,
      // 缩略图拖拽选择相关
      isDraggingThumbnail: false,
      thumbnailDragStartX: 0,
      thumbnailDragStartY: 0,
      thumbnailDragCurrentX: 0,
      thumbnailDragCurrentY: 0,
      thumbnailSelectionBoxStyle: {
        left: '0px',
        top: '0px',
        width: '0px',
        height: '0px'
      },
      thumbnailClickTarget: null,

      // 列表视图拖拽选择相关
      isDraggingList: false,
      listDragStartX: 0,
      listDragStartY: 0,
      listDragCurrentX: 0,
      listDragCurrentY: 0,
      listSelectionBoxStyle: {
        left: '0px',
        top: '0px',
        width: '0px',
        height: '0px'
      },
      listClickTarget: null,

      // 上传对话框
      showUploadDialog: false,
      // 新建文件夹对话框
      createFolderDialogVisible: false,
      creatingFolder: false,
      createFolderForm: {
        folderName: ''
      }

    }
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.handleMouseUp)
    window.removeEventListener('mousemove', this.handleMouseMove)
    window.removeEventListener('mouseup', this.handleThumbnailMouseUp)
    window.removeEventListener('mousemove', this.handleThumbnailMouseMove)
    window.removeEventListener('mouseup', this.handleListMouseUp)
    window.removeEventListener('mousemove', this.handleListMouseMove)
  },
  created() {
    if (this.advertiserId) {
      this.queryForm.advertiserId = this.advertiserId
    }
    this.loadFolderList()
    this.handleQuery()
    this.hasLoadedOnce = true
  },

  watch: {
    advertiserId(newVal) {
      if (newVal && newVal !== this.queryForm.advertiserId) {
        this.queryForm.advertiserId = newVal
        if (this.hasLoadedOnce) {
          this.handleQuery()
        }
      }
    }
  },

  computed: {
    currentFolderLabel() {
      if (!this.selectedFolder) {
        return '全部视频'
      }
      const folder = this.folderList.find(f => f.value === this.selectedFolder)
      return folder ? folder.label : this.selectedFolder
    },

    reviewStats() {
      return this.tableData.reduce((stats, row) => {
        const summary = row.reviewSummary || {}
        stats.passed += Number(summary.passed || 0)
        stats.rejected += Number(summary.rejected || 0)
        stats.pending += Number(summary.pending || 0)
        stats.partial += Number(summary.partial || 0)
        stats.unknown += Number(summary.unknown || 0)
        stats.noAdMaterial += Number(summary.noAdMaterial || 0)
        return stats
      }, { passed: 0, rejected: 0, pending: 0, partial: 0, unknown: 0, noAdMaterial: 0 })
    },

    currentPageRejectedVideos() {
      return this.tableData.filter(row => Number(row.reviewSummary?.rejected || 0) > 0)
    },

    selectedRejectedVideos() {
      return this.selectedVideos.filter(row => Number(row.reviewSummary?.rejected || 0) > 0)
    },

    currentPageDownloadableVideos() {
      return this.tableData.filter(row => row && row.previewUrl)
    }
  },

  methods: {
    async handleQuery() {
      this.loading = true

      try {
        const params = {
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        }

        params.advertiser_id = "7598883753192357896"

        if (this.queryForm.uploadPerson) {
          params.upload_person = this.queryForm.uploadPerson
        }

        if (this.queryForm.uploadType) {
          params.upload_type = this.queryForm.uploadType
          params.upload_video_type= this.queryForm.uploadType
        }

        // 从动态筛选条件中获取值
        const costFilter = this.advancedFilters.find(f => f.type === 'cost')
        const roasFilter = this.advancedFilters.find(f => f.type === 'roas')
        const impressionsFilter = this.advancedFilters.find(f => f.type === 'impressions')
        const keywordFilter = this.advancedFilters.find(f => f.type === 'keyword')
        const sortByFilter = this.advancedFilters.find(f => f.type === 'sortBy')
        const orderFilter = this.advancedFilters.find(f => f.type === 'order')

        // 检查是否使用了性能数据相关的查询条件
        const hasPerformanceFilter =
            (costFilter && (costFilter.minValue !== null || costFilter.maxValue !== null)) ||
            (roasFilter && (roasFilter.minValue !== null || roasFilter.maxValue !== null)) ||
            (impressionsFilter && impressionsFilter.value !== null) ||
            (keywordFilter && keywordFilter.value) ||
            sortByFilter ||
            orderFilter

        let response

        if (hasPerformanceFilter) {
          // 使用性能数据查询接口
          if (costFilter) {
            if (costFilter.minValue !== null) params.min_cost = costFilter.minValue
            if (costFilter.maxValue !== null) params.max_cost = costFilter.maxValue
          }

          if (roasFilter) {
            if (roasFilter.minValue !== null) params.min_roas = roasFilter.minValue
            if (roasFilter.maxValue !== null) params.max_roas = roasFilter.maxValue
          }

          if (impressionsFilter && impressionsFilter.value !== null) {
            params.min_impressions = impressionsFilter.value
          }

          if (keywordFilter && keywordFilter.value) {
            params.keyword = keywordFilter.value
          }

          if (sortByFilter) {
            params.sort_by = sortByFilter.value
          }

          if (orderFilter) {
            params.order = orderFilter.value
          }

          response = await axios.get(
              `${this.baseUrl}/material/lifetime/query`,
              {
                params,
                withCredentials: false,
                timeout: 30000
              }
          )


        } else {
          // 使用原有的视频记录查询接口
          response = await axios.get(
              `${this.baseUrl}/tiktok/video/v2/records`,
              {
                params,
                withCredentials: false,
                timeout: 30000
              }
          )
        }

        if (response.data.code === 200 || response.data.code === 0) {
          const data = response.data.data

          // 处理性能数据接口的返回格式
          let records = []
          let pagination = {}

          if (data.list) {
            // 性能数据接口返回格式：{ total, page, total_pages, list }
            records = data.list.map(item => ({
              id: item.videoUploadRecordId || item.uploadRecordId || item.recordId || null,
              lifetimeId: item.id,
              materialId: item.materialId,
              videoId: item.videoId,
              fileName: item.fileName,
              originalFileName: item.originalFileName,
              imageId: item.imageId,
              uploadVideoType: item.uploadVideoType,
              uploadPerson: item.uploadPerson,
              width: item.width,
              height: item.height,
              duration: item.duration,
              format: item.format,
              videoCoverUrl: item.videoCoverUrl,
              previewUrl: item.previewUrl,
              videoCoverUrlExpireTime: item.videoCoverUrlExpireTime,
              previewUrlExpireTime: item.previewUrlExpireTime,
              lastUrlRefreshTime: item.lastUrlRefreshTime,
              fileSize: item.fileSize,
              uploadStatus: item.uploadStatus,
              recordCreatedAt: item.createdAt,
              // 性能数据字段
              lifetimeCost: item.lifetimeCost,
              lifetimeImpressions: item.lifetimeImpressions,
              lifetimeClicks: item.lifetimeClicks,
              lifetimeConversions: item.lifetimeConversions,
              lifetimeRevenue: item.lifetimeRevenue,
              lifetimeRoas: item.lifetimeRoas,
              lifetimeCtr: item.lifetimeCtr,
              lifetimeCpc: item.lifetimeCpc,
              lifetimeCpm: item.lifetimeCpm,
              lifetimeConversionRate: item.lifetimeConversionRate,
              totalAdvertiserCount: item.totalAdvertiserCount,
              useCount: item.useCount,
              adUsageRecords: item.adUsageRecords,
              firstUsedDate: item.firstUsedDate,
              lastActiveDate: item.lastActiveDate,
              activeDays: item.activeDays,
              createdAt: item.createdAt,
              updatedAt: item.updatedAt,
              lastCalcTime: item.lastCalcTime,
              videoCoverUrlExpired: item.videoCoverUrlExpired,
              previewUrlExpired: item.previewUrlExpired,
              isDeleted: item.isDeleted,
              deletedAt: item.deletedAt,
              deletedBy: item.deletedBy,
              deleteReason: item.deleteReason
            }))

            pagination = {
              page: data.page,
              pageSize: this.pagination.pageSize,
              totalElements: data.total,
              totalPages: data.total_pages,
              hasNext: data.page < data.total_pages,
              hasPrevious: data.page > 1
            }
          } else {
            // 原有视频记录接口返回格式：{ records, page, pageSize, totalElements, ... }
            records = data.records || []
            pagination = {
              page: data.page,
              pageSize: data.pageSize,
              totalElements: data.totalElements,
              totalPages: data.totalPages,
              hasNext: data.hasNext,
              hasPrevious: data.hasPrevious
            }
          }

          this.tableData = records
          this.restoreSelectionState()
          this.pagination = pagination

          this.updateFolderCounts()
        } else {
          throw new Error(response.data.message || '查询失败')
        }
      } catch (error) {
        console.error('查询视频记录失败', error)
        this.$message.error('查询失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },
    // 检查是否已存在某种类型的筛选
    hasFilter(type) {
      return this.advancedFilters.some(f => f.type === type)
    },
    // 添加筛选条件
    handleAddFilter(command) {
      const filterMap = {
        cost: { type: 'cost', minValue: null, maxValue: null },
        roas: { type: 'roas', minValue: null, maxValue: null },
        impressions: { type: 'impressions', value: null },
        keyword: { type: 'keyword', value: '' },
        sortBy: { type: 'sortBy', value: 'lifetimeCost' },
        order: { type: 'order', value: 'desc' }
      }

      if (filterMap[command] && !this.hasFilter(command)) {
        this.advancedFilters.push({ ...filterMap[command] })
      }
    },

    // 删除筛选条件
    removeAdvancedFilter(index) {
      this.advancedFilters.splice(index, 1)
    },
    async loadFolderList() {
      try {
        const response = await axios.get(
            `${this.baseUrl}/upload-folder/list`,
            {
              withCredentials: false,
              timeout: 10000
            }
        )

        if (response.data.code === 200 || response.data.code === 0) {
          const folders = response.data.data || []

          this.folderList = folders.map(folder => ({
            label: folder.folderName,
            value: folder.folderName,
            count: undefined,
            id: folder.id,
            description: folder.folderDescription,
            uploadType: folder.uploadType
          }))

          if (this.uploadVideoType && !this.selectedFolder) {
            const matchFolder = this.folderList.find(f => f.value === this.uploadVideoType)
            if (matchFolder) {
              this.selectedFolder = this.uploadVideoType
            }
          }
        } else {
          throw new Error(response.data.message || '获取文件夹列表失败')
        }
      } catch (error) {
        console.error('加载文件夹列表失败', error)
        this.$message.warning('加载文件夹列表失败，使用默认列表')
      }
    },
    selectFolder(folderValue) {
      this.selectedFolder = folderValue
      this.queryForm.uploadType = folderValue
      this.pagination.page = 1
      this.handleQuery()
    },



    async updateFolderCounts() {
      for (const folder of this.folderList) {
        try {
          const params = {
            page: 1,
            page_size: 1,
            advertiser_id: this.advertiserId || "7598883753192357896",
            upload_type: folder.value,
            upload_video_type: folder.value
          }

          if (this.queryForm.uploadPerson) {
            params.upload_person = this.queryForm.uploadPerson
          }

          // 检查是否有高级筛选条件
          const costFilter = this.advancedFilters.find(f => f.type === 'cost')
          const roasFilter = this.advancedFilters.find(f => f.type === 'roas')
          const impressionsFilter = this.advancedFilters.find(f => f.type === 'impressions')
          const keywordFilter = this.advancedFilters.find(f => f.type === 'keyword')
          const sortByFilter = this.advancedFilters.find(f => f.type === 'sortBy')
          const orderFilter = this.advancedFilters.find(f => f.type === 'order')

          const hasPerformanceFilter =
              (costFilter && (costFilter.minValue !== null || costFilter.maxValue !== null)) ||
              (roasFilter && (roasFilter.minValue !== null || roasFilter.maxValue !== null)) ||
              (impressionsFilter && impressionsFilter.value !== null) ||
              (keywordFilter && keywordFilter.value) ||
              sortByFilter ||
              orderFilter

          let response

          if (hasPerformanceFilter) {
            // 使用性能数据接口
            if (costFilter) {
              if (costFilter.minValue !== null) params.min_cost = costFilter.minValue
              if (costFilter.maxValue !== null) params.max_cost = costFilter.maxValue
            }

            if (roasFilter) {
              if (roasFilter.minValue !== null) params.min_roas = roasFilter.minValue
              if (roasFilter.maxValue !== null) params.max_roas = roasFilter.maxValue
            }

            if (impressionsFilter && impressionsFilter.value !== null) {
              params.min_impressions = impressionsFilter.value
            }

            if (keywordFilter && keywordFilter.value) {
              params.keyword = keywordFilter.value
            }

            if (sortByFilter) {
              params.sort_by = sortByFilter.value
            }

            if (orderFilter) {
              params.order = orderFilter.value
            }

            response = await axios.get(
                `${this.baseUrl}/material/lifetime/query`,
                {
                  params,
                  withCredentials: false,
                  timeout: 10000
                }
            )

            if (response.data.code === 200 || response.data.code === 0) {
              // 性能数据接口返回的是 total
              folder.count = response.data.data.total
            }
          } else {
            // 使用原有视频记录接口
            response = await axios.get(
                `${this.baseUrl}/tiktok/video/v2/records`,
                {
                  params,
                  withCredentials: false,
                  timeout: 10000
                }
            )

            if (response.data.code === 200 || response.data.code === 0) {
              // 原有接口返回的是 totalElements
              folder.count = response.data.data.totalElements
            }
          }
        } catch (error) {
          console.error(`获取文件夹 ${folder.label} 数量失败`, error)
        }
      }
    },

    restoreSelectionState() {
      this.tableData.forEach(row => {
        if (row.videoId && row.imageId && this.selectedVideoIds.has(row.videoId)) {
          row._selected = true
          if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
            this.selectedVideos.push(row)
          }
        } else {
          row._selected = false
        }
      })
    },

    async refreshCurrentPageMaterialReview() {
      const payload = this.buildMaterialReviewPayload(this.tableData)
      if (payload.videoRecordIds.length === 0 && payload.materialIds.length === 0 && payload.videoIds.length === 0) {
        this.$message.warning('当前页缺少可查询的素材标识')
        return
      }

      this.materialReviewLoading = true
      try {
        const response = await axios.post(
            `${this.baseUrl}/smart-plus/material/review-info`,
            payload,
            {
              withCredentials: false,
              timeout: 60000
            }
        )

        if (response.data.code !== 200 && response.data.code !== 0) {
          throw new Error(response.data.message || '刷新审核统计失败')
        }

        const data = response.data.data || {}
        this.applyMaterialReviewSummaries(this.tableData, data.sourceSummaries || [])
        this.$message.success(`审核统计已刷新：通过 ${data.passed || 0}，失败 ${data.rejected || 0}`)
      } catch (error) {
        console.error('刷新审核统计失败', error)
        this.$message.error('刷新审核统计失败: ' + error.message)
      } finally {
        this.materialReviewLoading = false
      }
    },

    async handleDeleteRejectedOnPage() {
      await this.confirmDeleteRejectedVideos(this.currentPageRejectedVideos)
    },

    async handleDeleteSelectedRejected() {
      await this.confirmDeleteRejectedVideos(this.selectedRejectedVideos)
    },

    async confirmDeleteRejectedVideos(videos) {
      const rejectedVideos = videos || []
      if (rejectedVideos.length === 0) {
        this.$message.warning('没有已统计为不过审的素材')
        return
      }

      try {
        await this.$confirm(`确定要删除 ${rejectedVideos.length} 个存在审核失败记录的素材吗？`, '删除不过审素材', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await this.deleteVideosByMaterials(rejectedVideos, '审核失败')
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          this.$message.error('删除不过审素材失败: ' + error.message)
        }
      }
    },

    async deleteVideosByMaterials(videos, reason) {
      const payload = this.buildDeleteByMaterialPayload(videos)
      if (payload.materialIds.length === 0 && payload.videoIds.length === 0) {
        this.$message.warning('没有可删除的素材标识')
        return
      }

      this.deleteLoading = true
      try {
        const response = await axios.post(
            `${this.baseUrl}/tiktok/video/v2/records/delete-by-materials`,
            {
              ...payload,
              deletedBy: this.getCurrentUsername(),
              reason
            },
            {
              withCredentials: false,
              timeout: 30000
            }
        )

        if (response.data.code !== 200 && response.data.code !== 0) {
          throw new Error(response.data.message || '删除失败')
        }

        await this.handleQuery()
        this.$message.success('不过审素材已删除')
      } finally {
        this.deleteLoading = false
      }
    },

    buildMaterialReviewPayload(rows) {
      return {
        videoRecordIds: [...new Set((rows || []).map(row => row.id).filter(Boolean))],
        materialIds: [...new Set((rows || []).map(row => row.materialId).filter(Boolean))],
        videoIds: [...new Set((rows || []).map(row => row.videoId).filter(Boolean))],
        includeRejectInfo: true
      }
    },

    buildDeleteByMaterialPayload(rows) {
      return {
        materialIds: [...new Set((rows || []).map(row => row.materialId).filter(Boolean))],
        videoIds: [...new Set((rows || []).map(row => row.videoId).filter(Boolean))]
      }
    },

    applyMaterialReviewSummaries(rows, summaries) {
      const summaryMap = new Map()
      ;(summaries || []).forEach(summary => {
        if (summary.sourceRecordId) summaryMap.set(`record:${summary.sourceRecordId}`, summary)
        if (summary.sourceUploadMaterialId) summaryMap.set(`material:${summary.sourceUploadMaterialId}`, summary)
        if (summary.sourceVideoId) summaryMap.set(`video:${summary.sourceVideoId}`, summary)
      })

      rows.forEach(row => {
        const summary = summaryMap.get(`record:${row.id}`) ||
            summaryMap.get(`material:${row.materialId}`) ||
            summaryMap.get(`video:${row.videoId}`) ||
            { total: 0, passed: 0, rejected: 0, pending: 0, partial: 0, unknown: 0, noAdMaterial: 1 }
        this.$set(row, 'reviewSummary', summary)
      })
    },

    getReviewTagType(row) {
      const summary = row.reviewSummary
      if (!summary) return 'info'
      if (Number(summary.rejected || 0) > 0) return 'danger'
      if (Number(summary.pending || 0) > 0) return 'warning'
      if (Number(summary.passed || 0) > 0) return 'success'
      return 'info'
    },

    getReviewSummaryText(row) {
      const summary = row.reviewSummary
      if (!summary) return '未刷新'
      return `过${summary.passed || 0}/败${summary.rejected || 0}/审${summary.pending || 0}`
    },

    handleReset() {
      this.queryForm.uploadPerson = ''
      this.advancedFilters = []
      this.pagination.page = 1
      this.handleQuery()
    },
    handleRefresh() {
      this.pagination.page = 1
      this.handleQuery()
    },

    async handleDownloadCurrentPageVideos() {
      const videos = this.currentPageDownloadableVideos
      if (videos.length === 0) {
        this.$message.warning('当前页没有可下载的视频')
        return
      }

      try {
        await this.$confirm(
            `将下载当前筛选结果当前页的 ${videos.length} 个视频，是否继续？`,
            '下载当前页视频',
            {
              confirmButtonText: '下载',
              cancelButtonText: '取消',
              type: 'info'
            }
        )
      } catch (error) {
        return
      }

      this.downloadLoading = true
      let successCount = 0
      let failedCount = 0

      try {
        for (let i = 0; i < videos.length; i++) {
          try {
            await this.downloadVideoFromRow(videos[i], i)
            successCount += 1
          } catch (error) {
            failedCount += 1
            console.error('下载视频失败', videos[i], error)
          }
          await this.sleep(250)
        }

        if (failedCount > 0) {
          this.$message.warning(`已触发下载 ${successCount} 个，失败 ${failedCount} 个`)
        } else {
          this.$message.success(`已触发下载 ${successCount} 个视频`)
        }
      } finally {
        this.downloadLoading = false
      }
    },

    async downloadVideoFromRow(row, index) {
      const url = this.buildVideoDownloadUrl(row.previewUrl)
      const fileName = this.buildVideoDownloadFileName(row, index)
      this.triggerVideoDownload(url, fileName)
    },

    buildVideoDownloadUrl(url) {
      if (!url) return ''
      const separator = url.includes('?') ? '&' : '?'
      return `${url}${separator}download=true`
    },

    triggerVideoDownload(url, fileName) {
      if (!url) {
        throw new Error('缺少视频下载地址')
      }
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      link.rel = 'noopener'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    buildVideoDownloadFileName(row, index) {
      const rawName = row.fileName || row.originalFileName || `video_${this.pagination.page}_${index + 1}`
      const safeName = String(rawName)
          .replace(/[\\/:*?"<>|]+/g, '_')
          .replace(/\s+/g, ' ')
          .trim() || `video_${this.pagination.page}_${index + 1}`

      return /\.[a-zA-Z0-9]{2,5}$/.test(safeName) ? safeName : `${safeName}.mp4`
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    getCurrentUsername() {
      return this.$store.state.username || this.$store.state.user?.username || ''
    },

    buildDeleteSummary(videos) {
      const names = videos
          .map(row => row.fileName || row.originalFileName || `ID ${row.id}`)
          .filter(Boolean)
      const previewNames = names.slice(0, 5).join('、')
      const moreText = names.length > 5 ? ` 等 ${names.length} 个视频` : ''
      const usedCount = videos.filter(row => Number(row.useCount || 0) > 0).length
      const usedText = usedCount > 0 ? `\n其中 ${usedCount} 个视频已有使用记录，删除后只会从视频库隐藏。` : ''
      return `将删除 ${videos.length} 个视频：${previewNames}${moreText}${usedText}\n删除原因可不填。`
    },

    async confirmDeleteVideos(videos) {
      const validVideos = (videos || []).filter(row => row && row.id)
      if (validVideos.length === 0) {
        this.$message.warning('没有可删除的视频记录')
        return
      }

      try {
        const result = await this.$prompt(
            this.buildDeleteSummary(validVideos),
            '确认删除视频',
            {
              confirmButtonText: '删除',
              cancelButtonText: '取消',
              inputType: 'textarea',
              inputPlaceholder: '删除原因（可选）',
              inputValidator: value => !value || value.length <= 500 || '删除原因不能超过 500 字',
              confirmButtonClass: 'el-button--danger'
            }
        )
        await this.deleteVideos(validVideos, result.value || '')
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          this.$message.error('删除取消或失败')
        }
      }
    },

    async deleteVideos(videos, reason) {
      const ids = Array.from(new Set(videos.map(row => row.id).filter(Boolean)))
      if (ids.length === 0) {
        this.$message.warning('没有可删除的视频记录')
        return
      }

      this.deleteLoading = true
      try {
        const response = await axios.post(
            `${this.baseUrl}/tiktok/video/v2/records/delete`,
            {
              ids,
              deletedBy: this.getCurrentUsername(),
              reason
            },
            {
              withCredentials: false,
              timeout: 30000
            }
        )

        if (response.data.code !== 200 && response.data.code !== 0) {
          throw new Error(response.data.message || '删除失败')
        }

        const result = response.data.data || {}
        this.removeDeletedSelection(ids)
        await this.handleQuery()
        if (this.deleteRecordDialogVisible) {
          await this.loadDeletedRecords()
        }

        const failedCount = (result.failedIds || []).length
        const skippedCount = result.skippedCount || 0
        this.$message.success(`删除成功 ${result.deletedCount || 0} 个${skippedCount ? `，跳过 ${skippedCount} 个` : ''}${failedCount ? `，失败 ${failedCount} 个` : ''}`)
      } catch (error) {
        console.error('删除视频失败', error)
        this.$message.error('删除失败: ' + error.message)
      } finally {
        this.deleteLoading = false
      }
    },

    removeDeletedSelection(ids) {
      const idSet = new Set(ids.map(id => String(id)))
      this.selectedVideos = this.selectedVideos.filter(row => !idSet.has(String(row.id)))
      this.selectedVideoIds.clear()
      this.selectedVideos.forEach(row => {
        if (row.videoId) {
          this.selectedVideoIds.add(row.videoId)
        }
      })
      this.tableData.forEach(row => {
        if (idSet.has(String(row.id))) {
          row._selected = false
        }
      })
    },

    handleDeleteVideo(row) {
      this.confirmDeleteVideos([row])
    },

    handleBatchDelete() {
      this.confirmDeleteVideos(this.selectedVideos)
    },

    openDeletedRecordsDialog() {
      this.deleteRecordDialogVisible = true
      this.deletedRecordPagination.page = 1
      this.loadDeletedRecords()
    },

    async loadDeletedRecords() {
      this.deletedRecordLoading = true
      try {
        const params = {
          page: this.deletedRecordPagination.page,
          page_size: this.deletedRecordPagination.pageSize
        }

        if (this.deletedRecordQuery.uploadPerson) {
          params.upload_person = this.deletedRecordQuery.uploadPerson
        }
        if (this.deletedRecordQuery.fileName) {
          params.file_name = this.deletedRecordQuery.fileName
        }

        const response = await axios.get(
            `${this.baseUrl}/tiktok/video/v2/records/deleted`,
            {
              params,
              withCredentials: false,
              timeout: 30000
            }
        )

        if (response.data.code !== 200 && response.data.code !== 0) {
          throw new Error(response.data.message || '查询删除记录失败')
        }

        const data = response.data.data || {}
        this.deletedRecords = data.records || []
        this.deletedRecordPagination = {
          page: data.page || this.deletedRecordPagination.page,
          pageSize: data.pageSize || this.deletedRecordPagination.pageSize,
          totalElements: data.totalElements || 0,
          totalPages: data.totalPages || 0
        }
      } catch (error) {
        console.error('查询删除记录失败', error)
        this.$message.error('查询删除记录失败: ' + error.message)
      } finally {
        this.deletedRecordLoading = false
      }
    },

    handleDeletedRecordPageChange(page) {
      this.deletedRecordPagination.page = page
      this.loadDeletedRecords()
    },

    handleDeletedRecordSizeChange(size) {
      this.deletedRecordPagination.pageSize = size
      this.deletedRecordPagination.page = 1
      this.loadDeletedRecords()
    },

    resetDeletedRecordQuery() {
      this.deletedRecordQuery.uploadPerson = ''
      this.deletedRecordQuery.fileName = ''
      this.deletedRecordPagination.page = 1
      this.loadDeletedRecords()
    },

    handlePageChange(page) {
      this.pagination.page = page
      this.handleQuery()
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.handleQuery()
    },

    handlePreview(row) {
      this.previewUrl = row.previewUrl
      this.previewVisible = true
    },

    handleCopyInfo(row) {
      const info = `文件名: ${row.fileName}
视频ID: ${row.videoId || '无'}
素材ID: ${row.materialId || '无'}
状态: ${this.getStatusText(row.uploadStatus)}`

      this.copyToClipboard(info)
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('已复制到剪贴板')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },

    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '-'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i]
    },

    formatDuration(seconds) {
      if (!seconds) return '-'
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins}:${secs.toString().padStart(2, '0')}`
    },

    formatTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },

    getStatusType(status) {
      const types = {
        'SUCCESS': 'success',
        'FAILED': 'danger',
        'UPLOADING': 'warning',
        'PENDING': 'info'
      }
      return types[status] || 'info'
    },

    getStatusText(status) {
      const texts = {
        'SUCCESS': '成功',
        'FAILED': '失败',
        'UPLOADING': '上传中',
        'PENDING': '等待中'
      }
      return texts[status] || status
    },

    handleSelectionChange(selection) {
      selection.forEach(row => {
        if (row.videoId && row.imageId) {
          this.selectedVideoIds.add(row.videoId)
        }
      })

      const currentPageIds = new Set(this.tableData.map(row => row.videoId).filter(Boolean))

      this.selectedVideoIds.forEach(videoId => {
        if (!currentPageIds.has(videoId)) {
          const index = this.selectedVideos.findIndex(v => v.videoId === videoId)
          if (index !== -1) {
            this.selectedVideos.splice(index, 1)
          }
        }
      })

      this.selectedVideos = selection
    },

    handleCardSelectionChange(row) {
      if (row.videoId && row.imageId) {
        if (row._selected) {
          this.selectedVideoIds.add(row.videoId)
          if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
            this.selectedVideos.push(row)
          }
        } else {
          this.selectedVideoIds.delete(row.videoId)
          const index = this.selectedVideos.findIndex(v => v.videoId === row.videoId)
          if (index !== -1) {
            this.selectedVideos.splice(index, 1)
          }
        }
      } else {
        row._selected = false
        this.$message.warning('该视频缺少必要信息（videoId或imageId），无法选择')
      }
    },

    isVideoSelected(row) {
      return row.videoId && row.imageId && this.selectedVideoIds.has(row.videoId)
    },

    handleSelectAllOnPage() {
      this.tableData.forEach(row => {
        if (row.videoId && row.imageId) {
          row._selected = true
          this.selectedVideoIds.add(row.videoId)
          if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
            this.selectedVideos.push(row)
          }
        }
      })

      const selectableCount = this.tableData.filter(row => row.videoId && row.imageId).length
      if (selectableCount > 0) {
        this.$message.success(`已选中当前页 ${selectableCount} 个符合条件的视频`)
      } else {
        this.$message.warning('当前页没有符合条件的视频（需同时包含videoId和imageId）')
      }
    },

    checkSelectable(row) {
      return !!(row.videoId && row.imageId)
    },

    handleClearSelection() {
      this.selectedVideos = []
      this.selectedVideoIds.clear()
      this.tableData.forEach(row => {
        row._selected = false
      })
    },
    handleFileItemClick(row) {
      if (!row.imageId) {
        this.$message.warning('该视频缺少封面ID，无法选择')
        return
      }
      this.toggleCardSelection(row)
    },

    toggleCardSelection(row) {
      if (!row.videoId || !row.imageId) {
        row._selected = false
        return
      }

      row._selected = !row._selected

      if (row._selected) {
        this.selectedVideoIds.add(row.videoId)
        if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
          this.selectedVideos.push(row)
        }
      } else {
        this.selectedVideoIds.delete(row.videoId)
        const index = this.selectedVideos.findIndex(v => v.videoId === row.videoId)
        if (index !== -1) {
          this.selectedVideos.splice(index, 1)
        }
      }
    },
    async handleAssignToAds() {
      if (this.selectedVideos.length === 0) {
        this.$message.warning('请先选择要分配的视频')
        return
      }

      this.assignDialogVisible = true
    },

    confirmAssign() {
      if (this.selectedVideos.length === 0) {
        this.$message.warning('请先选择要分配的视频')
        return
      }

      const videos = this.selectedVideos.map(v => ({
        creative_info: {
          ad_format: 'SINGLE_VIDEO',
          video_info: {
            video_id: v.videoId,
            video_cover_url: v.videoCoverUrl || '',
            preview_url: v.previewUrl || ''
          },
          image_info: [{
            web_uri: v.imageId
          }],
          identity_type: "BC_AUTH_TT",
          identity_id: "1d955ad7-cceb-539d-97e5-875db5b789f9",
          identity_authorized_bc_id: "7596985632614989825"
        },
        selected: true,
        file_name: v.fileName || v.originalFileName || 'video.mp4'
      }))

      const result = {
        videos: videos,
        timestamp: new Date().getTime()
      }

      console.log('传递视频数据给父组件:', result)

      this.$emit('videos-assigned', result)

      this.assignDialogVisible = false
      this.handleClearSelection()

      this.$message.success(`已将 ${this.selectedVideos.length} 个视频传递给父组件`)
    },

    handleVideoHover(event, isEnter) {
      const video = event.target
      if (isEnter) {
        video.play().catch(() => {})
      } else {
        video.pause()
        video.currentTime = 0
      }
    },

    truncate(str, len) {
      if (!str) return ''
      return str.length > len ? str.substring(0, len) + '...' : str
    },
    isSelectingListItem(row) {
      if (!this.isDraggingList || !row.videoId || !row.imageId) {
        return false
      }

      const index = this.tableData.indexOf(row)
      const itemElement = document.querySelector(`.file-item[data-index="${index}"]`)
      if (!itemElement) return false

      const itemRect = itemElement.getBoundingClientRect()
      const containerRect = this.$refs.listViewContainer.getBoundingClientRect()

      const selectionLeft = Math.min(this.listDragStartX, this.listDragCurrentX)
      const selectionRight = Math.max(this.listDragStartX, this.listDragCurrentX)
      const selectionTop = Math.min(this.listDragStartY, this.listDragCurrentY)
      const selectionBottom = Math.max(this.listDragStartY, this.listDragCurrentY)

      const itemLeft = itemRect.left - containerRect.left
      const itemRight = itemLeft + itemRect.width
      const itemTop = itemRect.top - containerRect.top
      const itemBottom = itemTop + itemRect.height

      const isIntersecting = !(itemRight < selectionLeft ||
          itemLeft > selectionRight ||
          itemBottom < selectionTop ||
          itemTop > selectionBottom)

      return isIntersecting
    },

    handleListMouseDown(e) {
      if (e.button !== 0) return
      if (!e.target.closest('.list-view')) return

      const container = this.$refs.listViewContainer
      if (!container) return

      const rect = container.getBoundingClientRect()
      this.listDragStartX = e.clientX - rect.left
      this.listDragStartY = e.clientY - rect.top
      this.listDragCurrentX = this.listDragStartX
      this.listDragCurrentY = this.listDragStartY
      this.isDraggingList = true
      this.listClickTarget = e.target.closest('.file-item')

      e.preventDefault()

      window.addEventListener('mouseup', this.handleListMouseUp)
      window.addEventListener('mousemove', this.handleListMouseMove)
    },

    handleListMouseMove(e) {
      if (!this.isDraggingList) return

      const container = this.$refs.listViewContainer
      if (!container) return

      const rect = container.getBoundingClientRect()
      this.listDragCurrentX = e.clientX - rect.left
      this.listDragCurrentY = e.clientY - rect.top

      const left = Math.min(this.listDragStartX, this.listDragCurrentX)
      const top = Math.min(this.listDragStartY, this.listDragCurrentY)
      const width = Math.abs(this.listDragCurrentX - this.listDragStartX)
      const height = Math.abs(this.listDragCurrentY - this.listDragStartY)

      this.listSelectionBoxStyle = {
        left: left + 'px',
        top: top + 'px',
        width: width + 'px',
        height: height + 'px'
      }
    },

    handleListMouseUp(e) {
      if (!this.isDraggingList) return

      const dragDistance = Math.sqrt(
          Math.pow(this.listDragCurrentX - this.listDragStartX, 2) +
          Math.pow(this.listDragCurrentY - this.listDragStartY, 2)
      )

      const isClick = dragDistance < 5

      if (isClick && this.listClickTarget) {
        const index = parseInt(this.listClickTarget.getAttribute('data-index'))
        if (!isNaN(index) && this.tableData[index]) {
          const row = this.tableData[index]
          if (row.imageId) {
            this.toggleCardSelection(row)
          } else {
            this.$message.warning('该视频缺少封面ID，无法选择')
          }
        }
      } else if (!isClick) {
        const selectedInDrag = []

        this.tableData.forEach((row, index) => {
          if (!row.videoId || !row.imageId) return

          if (this.isSelectingListItem(row)) {
            row._selected = true
            this.selectedVideoIds.add(row.videoId)
            if (!this.selectedVideos.find(v => v.videoId === row.videoId)) {
              this.selectedVideos.push(row)
              selectedInDrag.push(row)
            }
          }
        })

        if (selectedInDrag.length > 0) {
          this.$message.success(`已选中 ${selectedInDrag.length} 个视频`)
        }
      }

      this.isDraggingList = false
      this.listSelectionBoxStyle = {
        left: '0px',
        top: '0px',
        width: '0px',
        height: '0px'
      }
      this.listClickTarget = null

      window.removeEventListener('mouseup', this.handleListMouseUp)
      window.removeEventListener('mousemove', this.handleListMouseMove)
    },
    handleUploadComplete(data) {
      this.$message.success(`视频上传完成！成功: ${data.successCount}, 失败: ${data.failedCount}`)
      setTimeout(() => {
        this.handleQuery()
      }, 1500)
    },

    showCreateFolderDialog() {
      this.createFolderForm.folderName = ''
      this.createFolderDialogVisible = true
    },

    async confirmCreateFolder() {
      const folderName = this.createFolderForm.folderName.trim()

      if (!folderName) {
        this.$message.warning('请输入文件夹名称')
        return
      }
      this.advertiserId='7598883753192357896'
      if (!this.advertiserId) {
        this.$message.warning('请先设置广告主ID')
        return
      }
      if (!(this.$store.state.username || this.$store.state.user)) {
        this.$message.warning('请先设置广告主ID')
        return
      }
      // 检查是否已存在同名文件夹
      const exists = this.folderList.some(folder => folder.value === folderName)
      if (exists) {
        this.$message.warning(`文件夹 "${folderName}" 已存在`)
        return
      }

      this.creatingFolder = true

      try {
        const response = await axios.post(
            `${this.baseUrl}/upload-folder/create`,
            {
              folderName: folderName,
              advertiserId: this.advertiserId,
              createdBy:this.$store.state.username || this.$store.state.user?.username || ''
            },
            {
              withCredentials: false,
              timeout: 10000
            }
        )

        if (response.data.code === 200 || response.data.code === 0) {
          const createdFolder = response.data.data

          this.$message.success(`文件夹 "${folderName}" 创建成功`)
          this.createFolderDialogVisible = false

          await this.loadFolderList()

          this.selectFolder(folderName)
        } else {
          throw new Error(response.data.message || '创建失败')
        }
      } catch (error) {
        console.error('创建文件夹失败', error)
        const errorMessage = error.response?.data?.message || error.message || '未知错误'
        this.$message.error('创建文件夹失败: ' + errorMessage)
      } finally {
        this.creatingFolder = false
      }
    },    handleImageError(event, row) {
      event.target.style.display = 'none'
      const iconElement = event.target.nextElementSibling
      if (iconElement) {
        iconElement.style.display = 'block'
      }
    }
  }

}
</script>

<style scoped>

.sidebar-header h3 i {
  margin-right: 8px;
  color: #409EFF;
}

.sidebar-actions {
  padding: 12px 16px;
  border-bottom: 1px solid #e4e7ed;
}

.sidebar-actions .create-folder-btn {
  width: 100%;
}



.video-library-page {
  height: calc(100vh - 100px);
}

.library-container {
  height: 100%;
}

.folder-sidebar {
  background: #fff;
  border-right: 1px solid #e4e7ed;
  overflow-y: auto;
}

.sidebar-header {
  padding: 16px;
  border-bottom: 1px solid #e4e7ed;
}

.sidebar-header h3 {
  margin: 0;
  font-size: 16px;
  color: #303133;
}

.sidebar-header h3 i {
  margin-right: 8px;
  color: #409EFF;
}

.folder-menu {
  padding: 8px;
}

.folder-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 4px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.folder-item:hover {
  background-color: #f5f7fa;
}

.folder-item.active {
  background-color: #ecf5ff;
  color: #409EFF;
}

.folder-item i {
  font-size: 18px;
  margin-right: 10px;
  color: #909399;
}

.folder-item.active i {
  color: #409EFF;
}

.folder-name {
  flex: 1;
  font-size: 14px;
}

.folder-badge {
  margin-left: 8px;
}

.all-folder {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e4e7ed;
}

.content-main {
  padding: 0;
  background: #f5f7fa;
  overflow-y: auto;
}

.query-card {
  margin: 16px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-left h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.header-left h3 i {
  margin-right: 8px;
  color: #409EFF;
}

.header-actions {
  display: flex;
  align-items: center;
}

.query-form {
  margin-bottom: 16px;
}

.stats-bar {
  margin-bottom: 16px;
}

.batch-actions {
  margin-bottom: 16px;
}

.action-buttons {
  margin-top: 12px;
  display: flex;
  gap: 8px;
}

.danger-text-btn {
  color: #f56c6c;
}

.danger-text-btn:hover {
  color: #f78989;
}

.id-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.copy-icon {
  cursor: pointer;
  color: #409EFF;
  font-size: 14px;
}

.copy-icon:hover {
  color: #66b1ff;
}

.card-view {
  margin-top: 16px;
}

.video-cards {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

/* 中等屏幕：每行4个 */
@media (max-width: 1600px) {
  .video-cards {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* 小屏幕：每行3个 */
@media (max-width: 1200px) {
  .video-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* 超小屏幕：每行2个 */
@media (max-width: 768px) {
  .video-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

.video-card {
  position: relative;
  background: #fff;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.video-card:hover {
  border-color: #409EFF;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}

.video-card.selected {
  border-color: #67c23a;
  background-color: #f0f9ff;
}

.video-checkbox {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 10;
}

.missing-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
}

.card-preview video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.card-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.card-preview {
  width: 100%;
  height: 180px;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}


.card-preview.no-preview {
  color: #909399;
  flex-direction: column;
}

.card-preview.no-preview i {
  font-size: 48px;
  margin-bottom: 8px;
}

.card-content {
  padding: 12px;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.card-title {
  font-weight: 500;
  font-size: 14px;
  color: #303133;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.review-summary-line {
  margin-bottom: 8px;
}
/* 卡片性能数据 */
.card-performance {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  padding: 8px;
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
  border-radius: 6px;
  border: 1px solid #e4e7ed;
}

.perf-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
  flex: 1;
  justify-content: center;
}

.perf-item i {
  font-size: 14px;
}

.cost-item {
  color: #f56c6c;
}

.cost-item i {
  color: #f56c6c;
}

.roas-item {
  color: #67c23a;
}

.roas-item i {
  color: #67c23a;
}
.card-info {
  font-size: 12px;
}

.info-item {
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-item .label {
  color: #909399;
  white-space: nowrap;
}

.info-item .value {
  color: #606266;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.copy-icon-small {
  cursor: pointer;
  color: #409EFF;
  font-size: 12px;
}

.copy-icon-small:hover {
  color: #66b1ff;
}

.thumbnail-view {
  margin-top: 16px;
}

.thumbnail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
}

.thumbnail-item {
  position: relative;
  background: #fff;
  border: 2px solid #e4e7ed;
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
}

.thumbnail-item:hover {
  border-color: #409EFF;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}

.thumbnail-item.selected {
  border-color: #67c23a;
}

.thumbnail-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.thumbnail-checkbox {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 10;
}

.thumbnail-missing-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 10;
  background: rgba(230, 162, 60, 0.9);
  color: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.thumbnail-preview {
  position: relative;
  width: 100%;
  aspect-ratio: 9 / 16;
  background: #f5f7fa;
  overflow: hidden;
}

.thumbnail-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.thumbnail-preview video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
.no-thumbnail-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 36px;
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.thumbnail-item:hover .play-overlay {
  opacity: 1;
}

.play-overlay i {
  font-size: 36px;
  color: #fff;
}

.thumbnail-info {
  padding: 8px;
}

.thumbnail-name {
  font-size: 12px;
  color: #303133;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.thumbnail-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
}

.thumbnail-delete-btn {
  color: #f56c6c;
  padding: 0;
}

.thumbnail-delete-btn:hover {
  color: #f78989;
}

.meta-tag {
  font-size: 10px;
}

.duration-text {
  font-size: 11px;
  color: #909399;
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
}

.selected-videos-list {
  max-height: 300px;
  overflow-y: auto;
}

.dialog-tip {
  line-height: 1.5;
}

/* 列表视图样式（文件管理器风格） */
.list-view {
  margin-top: 16px;
  min-height: 200px;
  position: relative;
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.file-item:hover {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
}

.file-item.selected {
  background-color: #ecf5ff;
  border-color: #409EFF;
}

.file-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.file-item.disabled:hover {
  background-color: #fff;
  border-color: transparent;
}

.file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 45px;
  margin-right: 12px;
  color: #409EFF;
  font-size: 24px;
  flex-shrink: 0;
  background: #ecf5ff;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.file-info {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.file-name {
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  line-height: 1.4;
}

.file-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  flex-wrap: wrap;
}

.meta-item {
  white-space: nowrap;
}

.meta-separator {
  color: #dcdfe6;
  margin: 0 2px;
}

.file-preview-btn {
  margin-left: 12px;
  flex-shrink: 0;
  font-size: 20px;
  color: #409EFF;
}

.file-preview-btn:hover {
  color: #66b1ff;
}

.file-delete-btn {
  margin-left: 8px;
  flex-shrink: 0;
  font-size: 20px;
  color: #f56c6c;
}

.file-delete-btn:hover {
  color: #f78989;
}

.delete-record-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.delete-record-pagination {
  margin-top: 16px;
  text-align: right;
}

.file-item.selecting {
  border-color: #409EFF;
  background-color: rgba(64, 158, 255, 0.08);
}

.list-selection-box {
  position: absolute;
  border: 2px solid #409EFF;
  background-color: rgba(64, 158, 255, 0.15);
  pointer-events: none;
  z-index: 100;
  border-radius: 4px;
}
.file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 45px;
  margin-right: 12px;
  color: #409EFF;
  font-size: 24px;
  flex-shrink: 0;
  background: #ecf5ff;
  border-radius: 6px;
  overflow: hidden;
}

.file-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.upload-dialog ::v-deep .el-dialog__body {
   padding: 20px;
   max-height: 80vh;
   overflow-y: auto;
 }

/* 高级筛选条件样式 */
.advanced-filter-item {
  animation: slideIn 0.3s ease;
  background: #f0f9ff;
  border-radius: 4px;
  padding: 4px 8px;
  margin-right: 8px !important;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 缩略图性能数据 */
.thumbnail-performance {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 6px;
  padding: 4px 6px;
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.thumbnail-performance .perf-item {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 500;
  flex: 1;
  justify-content: center;
}

.thumbnail-performance .perf-item i {
  font-size: 12px;
}
</style>
